import React, { useContext, useMemo, useState } from "react";
import { MANAGE_JOB, MODAL_STATES } from "../../../constant/Home/Jobs";
import Section from "../Details";
import Modal from "../../../Ui/Modal";
import ButtonComponent from "../../../Ui/Button";
import { UserContext } from "../../../context/UserContext";
import callApi from "../../../hooks/ApiHandler";
import useApiHandler from "../../../hooks/ApiHandler";
import { JobsApi } from "../../../../service";
import { generateManageJob, generatePostJobSummary } from "../../../constant/Home/Jobs";
import JobSummaryModal from "../../PostJob/JobSummaryModal";

const ManageJobComponent = ({ setModalState, currentSelectedData = {} }) => {
  const { userData } = useContext(UserContext);
  const { callApi, loading } = useApiHandler();
  const [showSummary, setShowSummary] = useState(false);

  const summarySections = useMemo(() => {
    if (!currentSelectedData || Object.keys(currentSelectedData).length === 0) {
      return [];
    }
    const sections = generatePostJobSummary(currentSelectedData);
    if (userData?.accountType === "HOMEOWNER" || userData?.accountType === "FAMILY_MEMBER") {
      return sections.filter((section) => section.title !== "Step 2 – Contact Info");
    }
    return sections;
  }, [currentSelectedData, userData?.accountType]);

  const fallbackSections = useMemo(() => {
    if (!currentSelectedData || Object.keys(currentSelectedData).length === 0) {
      return [];
    }
    return generateManageJob(
      currentSelectedData,
      currentSelectedData.status === "IN_PROGRESS"
    ).filter(
      (section) =>
        !(
          (userData?.accountType === "HOMEOWNER" || userData?.accountType === "FAMILY_MEMBER") &&
          section.title === "Tenant Information"
        )
    );
  }, [currentSelectedData, userData?.accountType]);

  const sectionsToRender = summarySections.length ? summarySections : fallbackSections;

  return (
    <>
      <Modal
        open={true}
        maxWidth="953px"
        onClose={() => setModalState("")}
        title="Manage Jobs"
        footer={
          <div className="flex w-full justify-between gap-2 sm2:flex-row flex-col ">
            <ButtonComponent paddingY="10px" onClick={() => setModalState("")}>
              Back
            </ButtonComponent>
            <div className="flex sm2:gap-4 gap-2 sm2:flex-row flex-col">
              {userData?.accountType !== "TENANT" && (
                <ButtonComponent
                  bgColor="#D40000"
                  color="#FFFFFF"
                  paddingY="10px"
                  onClick={() => setModalState(MODAL_STATES.CANCEL_JOB)}
                >
                  Cancel Job
                </ButtonComponent>
              )}
              <ButtonComponent
                paddingY="10px"
                onClick={() => setModalState("")}
                bgColor="#3CAB5C"
                color="#FFFFFF"
              >
                Message Vendor
              </ButtonComponent>
            </div>
          </div>
        }
      >
        <Section sections={sectionsToRender} />
      </Modal>

      {summarySections.length > 0 && (
        <JobSummaryModal
          open={showSummary}
          onClose={() => setShowSummary(false)}
          sections={summarySections}
          mode={MODAL_STATES.JOB_SUMMARY}
        />
      )}
    </>
  );
};

export default ManageJobComponent;
